const helpTopics = {
  en: [
    'Marketing',
    'Merchandising',
    'General',
    'General Training Support',
    'LMS Training Support'
  ],
  es: [
    'Commercialisation',
    'Marchandisage',
    'Générale',
    'Soutien à la formation générale',
    'Support de formation LMS'
  ]
};

export default helpTopics;
